import { takeEvery } from 'redux-saga/effects';

import { getAccountPath } from '../../utils/firebase';
import { fetchLabelFormatsRoutine } from '../routines';
import { fetchSaga } from './helper';

function* watchFetchLabelFormatsSaga() {
  yield takeEvery(fetchLabelFormatsRoutine.TRIGGER, fetchSaga(fetchLabelFormatsRoutine, () => getAccountPath('labelformats')));
}

export {
  watchFetchLabelFormatsSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/labelformats.js